import { useTranslation } from "react-i18next";

import type { StageSnapshot } from "@msc/shared";

import { formatIsoDate } from "../../lib/date.js";
import { StageLogos } from "./StageLogos.js";

/**
 * Abschlussfolie: Dank, die Bilanz des Termins und — wenn der Bereich welche
 * hat — die nächsten Termine als Raster. Unten, als Schlusspunkt, die Logos
 * von mindsquare und — sofern hinterlegt — dem Kunden (D10).
 *
 * Das Raster fehlt ersatzlos, wenn es nichts zu zeigen gibt. Ein leerer Kasten
 * mit Überschrift wäre eine Aussage über uns, die niemand treffen wollte.
 */
export function EndSlide({ snapshot }: { snapshot: StageSnapshot }) {
  const { t } = useTranslation();
  const stats = snapshot.stats;
  const events = snapshot.events ?? [];

  return (
    <div className="stage-slide">
      <h1 className="stage-title">{t("stage.thanks")}</h1>
      {stats && (
        <p className="stage-sub">
          {t("stage.stats", { done: stats.done, total: stats.total })}
        </p>
      )}
      {events.length > 0 && (
        <>
          <div className="stage-label">{t("stage.events")}</div>
          <ul className="stage-events">
            {events.map((e, index) => (
              <li key={index}>
                <div className="stage-event-head">
                  <span className="stage-event-date">{formatIsoDate(e.dateIso)}</span>
                  <span className="stage-label">{e.type}</span>
                </div>
                <div className="stage-event-title">{e.title}</div>
                {e.description !== "" && <p className="stage-event-desc">{e.description}</p>}
              </li>
            ))}
          </ul>
        </>
      )}
      <div className="stage-end-logos">
        <StageLogos customerLogoUrl={snapshot.branding?.logoUrl} />
      </div>
    </div>
  );
}
